module.exports = __webpack_public_path__ + "img/09600b3.jpg";